import { Switch } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";

export default styled(Switch)({
});